export const myHrTranslationsHu = {
  MY_HR_RESET_2FA_CONFIRM_INFO: "Valóban visszaállítja a hitelesítést alaphelyzetbe?",
  MY_HR_RESET_2FA_CONFIRM_RESET: "Alaphelyzetbe állítás megerősítése",
  MY_HR_VERIFICATION_CODE_MAX_ATTEMPTS_REACHED: "Elérte a megengedett próbálkozások számát a hitelesítő kód megadásakor",
  MY_HR_EMAIL_VERIFICATION_CODE_SENT: "A hitelesítő kódot elküldtük az email címére.",
  MY_HR_TWO_FACTOR_AUTHENTICATION_RESET_SUCCESS: "A kétfaktoros hitelesítés visszaállítása sikeresen megtörtént.",
  MY_HR_TWO_FACTOR_AUTHENTICATION_RESET_FAILED: "Hiba történt a kétfaktoros hitelesítés visszaálltása közben.",
  MY_HR_VERIFICATION_CODE_EXPIRED: "Ez a hitelesítő kód már lejárt!",
  MY_HR_INVALID_VERIFICATION_CODE: "Érvénytelen hitelesító kód!",
  MY_HR_2FA_CHOOSE_OPTION: "Két megoldás közül választhat:",
  MY_HR_EMAIL_BASED_AUTHENTICATION: "Email alapú hitelesítés",
  MY_HR_EMAIL_AUTHENTICATION_DESCRIPTION:
    "A jelszó megadása után az OrgwareConnect rendszer küld egy email-t önnek, ami egy egyszeri kódot tartalmaz. Az egyszeri kódot pedig megadott időtartamig tudja beírni a megfelelő mezőbe.",
  MY_HR_APP_BASED_AUTHENTICATION: "Alkalmazás alapú hitelesítés",
  MY_HR_APP_AUTHENTICATION_DESCRIPTION:
    "A jelszó megadása után a második kódot a hitelesítő alkalmazásban fogja megtalálni, ez a kód folyamatosan változik. Több alkalmazás is létezik, az egyik legnépszerűbb a Google Hitelesítő alkalmazása, ami elérhető Android és iOS rendszeren is (ezen kívül pl.: 1Password, Authy, Apple Jelszavak, stb.). A kód elérését QR kóddal vagy egyéb módon kell beállítani az alkalmazásba.",
  MY_HR_2FA_DESCRIPTION:
    "A kétfaktoros hitelesítés (2FA) egy olyan biztonsági módszer, amely során a bejelentkezési e-mail és jelszó mellett a felhasználónak meg kell erősítenie személyazonosságát. Ez minimálisra csökkenti a fiókjához való jogosulatlan hozzáférés és az adatokkal való visszaélés kockázatát.",
  MY_HR_2FA_MANDATORY_FROM_DATE:
    "{{date}} napjától a kétlépcsős hitelesítés kötelezővé válik az OrgwareConnect fiókjába való bejelentkezéshez.",
  MY_HR_USER_LOCKED: "Felhasználó zárolva",
  MY_HR_INACTIVE: "Inaktív",
  MY_HR_USER_NOT_REGISTERED_2FA: "Felhasználó még nem regisztrálta fiókján a kétfaktoros hitelesítést.",
  MY_HR_AUTH_CODE_FAILED_THREE_TIMES: "Felhasználó háromszor egymás után hibásan adta meg a hitelesítő kódot.",
  MY_HR_TWO_FACTOR_AUTHENTICATION_ACTIVE: "Felhasználó regisztrálta fiókján a kétfaktoros hitelesítést.",
  MY_HR_ACCOUNT_LOCKED_AFTER_FAILED_ATTEMPTS: "Ön háromszor sikertelenül próbált bejelentkezni, ezért a rendszerből biztonsági okokból kizárásra került. Kérem forduljon a helyi rendszergazdához.",
  MY_HR_REGISTRATION_DEADLINE: "Regisztrációs határidő",
  MY_HR_ENABLED_2FA: "Hitelesítő ugrókód alkalmazása email, vagy hitelesítő alkalmazás használatával.",
  MY_HR_RETRY_QR_CODE_SCAN: "Próbálja újra beolvasni a QR-kódot",
  MY_HR_ENTER_MANUAL_CODE_INTO_AUTH_APP: "Ha nem tudja beolvasni a QR-kódot a kamerával, írja be a következő kódot a hitelesítő alkalmazásba, hogy összekapcsolja azt az OrgwareConnect fiókjával:",
  MY_HR_CANNOT_SCAN_QR_CODE: "Nem tudja beolvasni a QR-kódot?",
  MY_HR_SCAN_QR_WITH_AUTHENTICATOR_APP: "Használja hitelesítő alkalmazását a QR-kód beolvasásához. Ha nincs hitelesítő alkalmazás az eszközén, telepítenie kell egyet.",
  MY_HR_ENTER_VERIFICATION_CODE: "Írja be a megerősítő kódot.",
  MY_HR_USE_COMPATIBLE_AUTHENTICATOR_APP: "Használjon kompatibilis hitelesítő alkalmazást (pl.: Google Authenticator, Authy, Apple Passwords, stb.). Létrehozunk egy QR-kódot amelyet beolvashat.",
  MY_HR_LINK_AUTHENTICATOR_APP: "Kapcsoljon hitelesítő alkalmazást OrgwareConnect fiókjához",
  MY_HR_PROTECT_ACCOUNT_TWO_STEPS: "Védje fiókját mindössze két lépésben",
  MY_HR_SECONDS_REMAINING: "Még {{countdown}} másodperc",
  MY_HR_SEND_AUTHENTICATION_EMAIL: "Hitelesítő email küldése",
  MY_HR_EMAIL_CODE_REQUEST: "Személyazonosságának igazolásához írja be az email-ben kiküldött kódot.",
  MY_HR_VERIFICATION: "Ellenőrzés",
  MY_HR_ENTER_AUTHENTICATION_CODE: "Írja be a hitelesítő kódot",
  MY_HR_2FA_APP_LOGIN_INFO: "Személyazonosságának igazolásához írja be a kétfaktoros hitelesítő alkalmazás által generált kódot.",
  MY_HR_2FA_AUTHENTICATION: "Kétfaktoros hitelesítés",
  MY_HR_2FA_DATE_INFO: "A kétfaktoros hitelesítés {{date}} napjától kötelező lesz.",
  MY_HR_NOT_SET_UP_2FA: "Önnek még nincs beállítva a kétfaktoros hitelesítés",
  MY_HR_TWO_FACTOR_AUTHENTICATION_TYPE: "Hitelesítés típusa",
  MY_HR_RESET_TWO_FACTOR_AUTHENTICATION_INFO: "A jelenlegi titkos kulcs megváltoztatását kezdeményezheti, hitelesítő alkalmazás esetén újra kell regisztrálni az első belépésekor.",
  MY_HR_RESET_TWO_FACTOR_AUTHENTICATION: "Kétlépcsős hitelesítés alaphelyzetbe állítása",
  MY_HR_TWO_FACTOR_AUTHENTICATION: "Kétlépcsős hitelesítés",
  MY_HR_MYINFO_PAGE_TITLE: "Általános információim",
  MY_HR_USER_DATA_EDIT_PAGE_PAGE_TITLE: "Adatváltozás kérelmek elbírálása",
  MY_HR_ADMIN_USERS_PAGE_TITLE: "Felhasználók kezelése",
  MY_HR_OTHER_USER_PAGE_TITLE: "Felhasználói fiók kezelése",
  MY_HR_ADD_ALL_PERMISSIONS_DIALOG_INFO: "Amennyiben nincs beállítva szűrőfeltétel, úgy az összes dolgozó a szerephez fog tartozni.",
  MY_HR_ERROR_MESSAGE_NO_CONTRACT_FOUND: "Nem található érvényes jogviszony!",
  MY_HR_POSITION: "Beosztás",
  MY_HR_NOT_HAVE_ROLE: "Ilyen szereppel nem rendelkezett a felhasználó.",
  MY_HR_ERROR_MESSAGE_INVALID_USERNAME: "Nem megfelelő felhasználónév!",
  MY_HR_ACCEPTABLE_DISTRICT_FORMAT: "Elfogadott formátum: 01, 12 stb.",
  MY_HR_PASSWORD_VISIBILITY_INFO: "A beírt jelszó ellenőrizhetősége kedvéért a szem ikonnal megadhatjuk a felhasználónak a lehetőséget, hogy megnézze, valóban azt gépelte-e, amit szeretett volna.",
  MY_HR_PASSWORD_VISIBILITY: "Jelszó láthatóság",
  MY_HR_ADD_ROLE_ERROR: "A szerep hozzáadása hibákkal lefutott!",
  MY_HR_CONTRACT_NOT_PERMISSION_TO_LEAVE: "Erre a jogviszonyra nem állapítható meg szabadság",
  MY_HR_CHANGE_REQUESTS: "Adatváltozás kérelmek",
  MY_HR_MY_CHANGE_REQUEST: "Adatváltozás kérelmeim",
  MY_HR_CHANGE_REQUEST_EMAIL: "Változásjelentés e-mail cím",
  MY_HR_NOT_VALID_PHONE_NUMBER: "Nem megfelelő telefonszám formátum!",
  MY_HR_CHANGE_REQUEST_SETTINGS: "Változásjelentés",
  MY_HR_EDIT_SERVICE_ADDRESS: "Szolgálati cím szerkesztése",
  MY_HR_EDIT_TEMPORARY_ADDRESS: "Ideiglenes lakcím szerkesztése",
  MY_HR_EDIT_PERMANENT_ADDRESS: "Lakóhely szerkesztése",
  MY_HR_EDIT_EMAILS_OTHER: "Egyéb email szerkesztése",
  MY_HR_EDIT_EMAILS_WORK: "Munkahelyi email szerkesztése",
  MY_HR_EDIT_PHONES_PRIVATE: "Magán telefonszám szerkesztése",
  MY_HR_EDIT_PHONES_WORK_MOBILE: "Munkahelyi mobiltelefonszám szerkesztése",
  MY_HR_EDIT_PHONES_WORK: "Munkahelyi telefonszám szerkesztése",
  MY_HR_ADD_GROUP_PASSWORD_NOT_ON_SSO: "Ez a rendszer egyszeri bejelentkezést (single sign on) használ. Az ilyen rendszerekben az automatikus jelszógenerálás nem lehetséges.",
  MY_HR_AUTOMATIC_PASSWORD_GENERATION: "Automatikus jelszógenerálás",
  MY_HR_AUTOMATIC_PASSWORD_GENERATION_INFO: "A kapcsoló aktiválásával az importálás folyamán minden új felhasználó számára egy átmeneti, kezdeti jelszót generálunk, amelyet emailben ki is küldünk. Első belépéskor ezt a jelszót meg kell változtatni. Ezt a lépést később is meg lehet tenni.",
  MY_HR_SEND_GROUP_PASSWORDS_DIALOG_TITLE: "Csoportos jelszó megadás megerősítése",
  MY_HR_SEND_GROUP_PASSWORDS_DIALOG_TEXT: "Valóban megadja a jelszót a kiválasztott dolgozó(k)nak?",
  MY_HR_SEND_GROUP_PASSWORDS_TO_ALL_DIALOG_TEXT: "Valóban megadja a jelszót az összes dolgozónak?",
  MY_HR_SEND_GROUP_PASSWORDS_INFO: "Új jelszó hozzáadása a jelenlegi OrgwareConnect felhasználókhoz.",
  MY_HR_SEND_GROUP_PASSWORDS_SUCCEEDED: "A jelszó hozzáadása hibátlanul lefutott",
  MY_HR_PASSWORD_SENT: "jelszó hozzáadva",
  MY_HR_PASSWORD_SWITCH_TEXT: "Meglévő jelszavak cseréje",
  MY_HR_SEND_PASSWORD_INFO_TEXT: "A gomb megnyomásával a szűrő által kiválasztott valamennyi dolgozónak új jelszót hozunk létre, amelyet az első belépéskor meg kell változtatnia. A jelszó generálásáról a dolgozók email-ben kapnak tájékoztatást.",
  MY_HR_ADD_GROUP_PASSWORD_TITLE: "Csoportos jelszó hozzáadása",
  MY_HR_ROLE_REMOVED: "szerep eltávolítva",
  MY_HR_REMOVE_ROLE_SUCCEEDED: "A csoportos szerep elvétel sikeresen végetért.",
  MY_HR_REQUEST_PERMIT: "Engedélykérés",
  MY_HR_PERMIT_REQUESTED: "Az engedélykérés elküldve.",
  MY_HR_IT_IS_ALREADY_GRANTED: "Ez a kérelem már el lett fogadva!",
  MY_HR_PERMIT_GRANTED: "Orgware Admin Login engedélyezve az Orgware Kft. munkatársa számára.",
  MY_HR_SYSTEM_USER_NAME: "Szervíz felhasználó név",
  MY_HR_SYSTEM_USER_PASSWORD: "Szervíz felhasználó jelszó",
  MY_HR_DOMAIN_SUFFIX: "Domain utótag",
  MY_HR_CONTRACT_ALREADY_HAS_THIS_ROLE: "A jogviszony már rendelkezik ezzel a jogosultsággal.",
  MY_HR_ADD_GROUP_ROLE_DIALOG_TITLE: "Csoportos szerep hozzáadás megerősítése",
  MY_HR_ADD_GROUP_ROLE_TO_ALL_DIALOG_TEXT: "Valóban minden dolgozónak megadja a kiválasztott szerepet?",
  MY_HR_ADD_GROUP_ROLE_DIALOG_TEXT: "Valóban megadja a szerepet a kiválasztott dolgozó(k)nak?",
  MY_HR_REMOVE_GROUP_ROLE_DIALOG_TITLE: "Csoportos szerep elvétel megerősítése",
  MY_HR_REMOVE_GROUP_ROLE_TO_ALL_DIALOG_TEXT: "Valóban minden dolgozótól elveszi a kiválasztott szerepet?",
  MY_HR_REMOVE_GROUP_ROLE_DIALOG_TEXT: "Valóban elveszi a szerepet a kiválasztott dolgozó(k)tól?",
  MY_HR_INACTIVATE_USERS_TO_ALL_DIALOG_TEXT: "Valóban szűrés nélkül inaktiválja az összes dolgozót?",
  MY_HR_INACTIVATE_USERS_DIALOG_TEXT: "Valóban inaktiválja a kiválasztott dolgozó(ka)t?",
  MY_HR_INACTIVATE_USERS_SUCCESSFULLY: "A felhasználó(k) sikeresen inaktiválva",
  MY_HR_INACTIVATE_USERS_FAILED: "Hiba történt az inaktiválás során.",
  MY_HR_INACTIVATE_USERS_DIALOG_TITLE: "Csoportos inaktiválás megerősítése",
  MY_HR_INACTIVATE: "Kezelés",
  MY_HR_INACTIVATE_BUTTON: "Inaktiválás",
  MY_HR_ADD_ROLE_SUCCEEDED: "A szerep hozzáadása hibátlanul lefutott!",
  MY_HR_ROLE_ADDED: "szerep hozzáadva",
  MY_HR_ADD_MASS_ROLE: "Új szerep hozzáadása",
  MY_HR_ADD_MASS_ROLE_INFO: "Új szerep hozzáadása a jelenlegi OrgwareConnect felhasználókhoz.",
  MY_HR_REMOVE_MASS_ROLE: "Szerep eltávolítása",
  MY_HR_REMOVE_MASS_ROLE_INFO: "Szerep eltávolítása a jelenlegi OrgwareConnect felhasználóktól.",
  MY_HR_ADD_PERMISSION: "Jogosultság megadása",
  MY_HR_ADD_ROLE: "Szerep hozzáadása",
  MY_HR_REMOVE_ROLE: "Szerep elvétel",
  MY_HR_ADDRESS: "Cím",
  MY_HR_ALL_TAX_DEDUCTIONS: "Összes adó- és járuléklevonás",
  MY_HR_BIRTH_CARD_TITLE: "Természetes azonosítók",
  MY_HR_BUTTON_SEND: "Elküldöm",
  MY_HR_CHANGE_TEMPORARY_PASSWORD_TAX_NUMBER_ERROR: "A megadott adóazonosító jel nem található a rendszerben.",
  MY_HR_CITY: "Település",
  MY_HR_CODE_CARD_TITLE: "Kódolt azonosítók",
  MY_HR_CONFIRM_NEW_PASSWORD: "Új jelszó megerősítése",
  MY_HR_CONTACTS: "Elérhetőségek",
  MY_HR_CONTRACT_TYPE: "Törvény típusa",
  MY_HR_GET_CONTRACT: "Szerződés",
  MY_HR_COUNTRY_OF_BIRTH: "Születési ország",
  MY_HR_COUNTRY: "Ország",
  MY_HR_CREATE_USER: "Felhasználó létrehozása",
  MY_HR_CURRENT_PASSWORD: "Aktuális jelszó",
  MY_HR_DATE_OF_BIRTH: "Születési dátum",
  MY_HR_DEDUCTIONS: "Levonások",
  MY_HR_EMAIL_OTHER: "Egyéb email",
  MY_HR_EMAIL_WORK: "Munkahelyi email",
  MY_HR_EMAIL: "Email",
  MY_HR_EMPLOYMENT_TYPE: "Foglalkoztatás jellege",
  MY_HR_ERROR_MESSAGE_INVALID_EMPLOYEE_CODE: "Érvénytelen személykód!",
  MY_HR_ERROR_MESSAGE_NO_USER_FOUND: "Nincs ilyen felhasználó!",
  MY_HR_ERROR_MESSAGE_PASSWORD_IS_REQUIRED: "A jelszó megadása kötelező!",
  MY_HR_ERROR_MESSAGE_TWO_PASSWORD_IS_DIFFERENT: "A két jelszó nem egyezik meg!",
  MY_HR_ERROR_MESSAGE_USERNAME_IS_REQUIRED: "Az azonosító megadása kötelező!",
  MY_HR_ERROR_MESSAGE_WRONG_EMAIL_FORMAT: "Nem megfelelő email cím formátum!",
  MY_HR_ERROR_MESSAGE_WRONG_PASSWORD: "Hibás jelszó!",
  MY_HR_ERROR_MESSAGE_WRONG_USERNAME_OR_PASSWORD: "Hibás felhasználónév vagy jelszó!",
  MY_HR_ERROR_MESSAGE_ACCOUNT_HAS_EXPIRED: "A felhasználói jogosultsága lejárt!",
  MY_HR_FIRST_NAME: "Keresztnév",
  MY_HR_GENDER: "Neme",
  MY_HR_GROSS_WAGE: "Havi bruttó juttatás",
  MY_HR_IDENTITY_CARD_NUMBER: "Személyazonosító okmány",
  MY_HR_INFO_TEXT_NOT_STRONG_PASSWORD: "A jelszó minimum 8 karakter hosszú és tartalmaznia kell betűket és számokat.",
  MY_HR_INFO_TEXT_DIRECTORY: "Az Címtáras autentikáció használatával az azonosítást nem az OrgwareConnect rendszer végzi.",
  MY_HR_INFO_TEXT_STRONG_PASSWORD: "A jelszó minimum 8 karakter hosszú és az alábbiakat kell tartalmaznia: kisbetű, nagybetű, szám, szimbólum. A jelszó nem egyezhet meg az utolsó 5 jelszóval.",
  MY_HR_JOB_CLASS: "Munkakör",
  MY_HR_LAST_LOGIN: "Utolsó belépés",
  MY_HR_LAST_NAME: "Családnév",
  MY_HR_GET_LAST_PASSWORD_CHANGE: "Utolsó módosítás dátuma",
  MY_HR_LINK_BACK_TO_LOGIN: "Vissza a bejelentkezéshez",
  MY_HR_LINK_FORGOT_PASSWORD: "Elfelejtette a jelszavát?",
  MY_HR_LOGIN: "Belépés",
  MY_HR_LOGOUT: "Kilépés",
  MY_HR_MARITAL_STATUS: "Családi állapot",
  MY_HR_MIDDLE_NAME: "Keresztnév 2",
  MY_HR_MOTHERS_NAME: "Anyja neve",
  MY_HR_MY_PROFILE: "Profilom",
  MY_HR_NAME_SUFFIX: "Utónév",
  MY_HR_NATIONALITY: "Állampolgárság",
  MY_HR_NET_WAGE: "Nettó juttatás",
  MY_HR_NEW_PASSWORD: "Új jelszó",
  MY_HR_NEW_USER: "Új felhasználó",
  MY_HR_NO_PAYROLL_DATA: "Ebben a hónapban nem található bérszámfejtési adat.",
  MY_HR_ORGWARE_COMPANY_NAME: "Orgware Kft.",
  MY_HR_OTHER_DEDUCTIONS: "Egyéb levonás, juttatások",
  MY_HR_PASSWORD: "Jelszó",
  MY_HR_PAYROLL: "Bérlap",
  MY_HR_PAYROLL_MENU_INFO: "A bérlap menü megjelenítése",
  MY_HR_PERMANENT_ADDRESS: "Lakóhely",
  MY_HR_PERMISSION: "Jogosultság",
  MY_HR_PERSONAL_DATA: "Személyes adatok",
  MY_HR_PHONE_PRIVATE: "Egyéb",
  MY_HR_PHONE_WORK: "Munkahelyi telefon",
  MY_HR_PHONE_WORKMOBILE: "Munkahelyi mobil",
  MY_HR_PLACE_OF_BIRTH: "Születési hely",
  MY_HR_PREFIX_NAME: "Előnév",
  MY_HR_PRESENT: "jelen",
  MY_HR_RECOVER_YOUR_PASSWORD: "Jelszó visszaállítása",
  MY_HR_RESTORE: "Visszaállítás",
  MY_HR_ROLE_USER: "Felhasználó",
  MY_HR_ROLE_ADMIN: "Adminisztrátor",
  MY_HR_ROLE_EXAMINER: "Elbíráló",
  MY_HR_ROLE_VIEWER: "Megtekintő",
  MY_HR_ROLE_ASSIGNER: "Kiíró",
  MY_HR_ROLE_UPLOADER: "Feltöltő",
  MY_HR_ROLE_EDITOR: "Szerkesztő",
  MY_HR_ROLES: "Szerepek",
  MY_HR_SELECT_EMPLOYEE: "Dolgozó kiválasztása",
  MY_HR_SEND_NEW_TEMPORARY_PASSWORD: "Új ideiglenes jelszó küldése",
  MY_HR_SEND_TEMPORARY_PASSWORD_TEXT:
    "A jelenlegi jelszó megváltoztatását kezdeményezheti egy ideiglenes jelszó küldésével, melyet a felhasználónak meg kell változtatnia az első belépésekor.",
  MY_HR_SERVICE_ADDRESS: "Szolgálati cím",
  MY_HR_SHIFT_TYPE: "Műszak típusa",
  MY_HR_SIGN_IN: "Bejelentkezés",
  MY_HR_SELECTED_COMPANY: "Bejelentkező oldalon megjelenő cég neve",
  MY_HR_SELECT_COMPANY: "Cég kiválasztása",
  MY_HR_SOCIAL_SECURITY_NUMBER: "Társadalombiztosítási azonosító jel",
  MY_HR_SYSTEM_SETTINGS: "Rendszerbeállítások",
  MY_HR_SYSTEM: "Rendszer",
  MY_HR_TAX_NUMBER: "Adóazonosító jel",
  MY_HR_TELEPHONE: "Telefon",
  MY_HR_TEMPORARY_ADDRESS: "Tartózkodási hely",
  MY_HR_TEMPORARY_PASSWORD_EMAIL_SENT: "Az ideiglenes jelszó értesítő levél elküldve",
  MY_HR_TEXT_COPYRIGHT: "Minden jog fenntartva!",
  MY_HR_TEXT_EMAIL_SENT: "A segítség úton van. Az ideiglenes jelszó segítségével létrehozhatja új jelszavát.",
  MY_HR_TEXT_FORGOT_PASSWORD_IS_NOT_AVAILABLE:
    "A program jelszó helyreállító szolgáltatása nem használható központi azonosítást használó ügyfelek esetében. Kérjük vegy fel a kapcsolatot a rendszergazdával.",
  MY_HR_TEXT_PUBLIC_LAYOUT: "HR és Bérszámfejtés zavartalanul!",
  MY_HR_TEXT_SEND_EMAIL_DESCRIPTION: "Küldje el email címét és mi elküldünk egy ideiglenes jelszót, amely segítségével létrehozhatja új jelszavát.",
  MY_HR_TEXT_UNLOCK: "Tétlenség miatt a rendszer kiléptette. A folytatáshoz írja be a jelszavát.",
  MY_HR_TITLE_EMAIL_SENT: "Elküldtük az ideiglenes jelszót",
  MY_HR_TITLE_FORGOT_PASSWORD_IS_NOT_AVAILABLE: "A jelszó helyreállítása nem lehetséges",
  MY_HR_TITLE_UNLOCK: "A rendszer kiléptette",
  MY_HR_UNLOCK: "Feloldás",
  MY_HR_UNSAVED_ELEMENTS: "Az oldalon nem mentett elemek találhatók!",
  MY_HR_USER_ACCOUNT: "Felhasználói fiók",
  MY_HR_USER: "Felhasználó",
  MY_HR_USERNAME: "Azonosító",
  MY_HR_USERS: "Felhasználók",
  MY_HR_USING_STRONG_PASSWORD: "Erős jelszó használata",
  MY_HR_VIEW_MY_PAYCARD: "Megnézem a bérlapom",
  MY_HR_ZIP: "Irányítószám",
  MY_HR_ERROR_MESSAGE_PASSWORD_IS_WRONG: "A jelszó nem felel meg a házirendnek!",
  MY_HR_NOT_LOGGED_IN: "Még nem lépett be",
  MY_HR_PASSWORD_CHANGE_SUCCEEDED: "A jelszó megváltoztatása sikeresen megtörtént",
  MY_HR_ROLE_CREATED_SUCCESSFULLY: "Szerep sikeresen hozzáadva",
  MY_HR_ROLE_CREATION_FAILED: "Hiba történt a szerep hozzáadása közben!",
  MY_HR_ROLE_REMOVED_SUCCESSFULLY: "Szerep sikeresen eltávolítva",
  MY_HR_ROLE_REMOVE_FAILED: "Hiba történt a szerep eltávolítása közben!",
  MY_HR_ROLE_UPDATED_SUCCESSFULLY: "Szerep sikeresen módosítva",
  MY_HR_ROLE_UPDATE_FAILED: "Hiba történt a szerep módosítása közben!",
  MY_HR_ABOUT: "Névjegy",
  MY_HR_USER_GUIDES: "Felhasználói kézikönyvek",
  MY_HR_USER_GUIDE: "MyHR felhasználói kézikönyv",
  MY_HR_ADMIN_GUIDE: "MyHR adminisztrátori kézikönyv",
  MY_HR_ERROR_MESSAGE_EMAIL_IS_EXIST: "Ez az email cím már létezik!",
  MY_HR_IMPORT_USERS: "Felhasználók importálása",
  MY_HR_IMPORT_USERS_FROM_JDOLBER: "Felhasználók importálása JDolBer-ből",
  MY_HR_IMPORT_USERS_FROM_SSHR: "Felhasználók importálása NextGen SSHR rendszerből",
  MY_HR_IMPORT_USERS_TEXT_INFO: "Új felhasználók importálása a JDolBer Humánügyviteli rendszerből. Az importálás nincs hatással a jelenlegi OrgwareConnect felhasználókra. A folyamat akár néhány percig is eltarthat!",
  MY_HR_IMPORT_SSHR_USERS_TEXT_INFO: "Új felhasználók importálása a NextGen SSHR rendszerből. Az importálás nincs hatással a jelenlegi OrgwareConnect felhasználókra. A folyamat akár néhány percig is eltarthat!",
  MY_HR_IMPORT_SSHR_USERS_LOCKED_INFO: "A felhasználók importálása funkció jelenleg nem elérhető, mert már egy másik import folyamat fut.",
  MY_HR_EMPLOYEE_CODE: "Személykód",
  MY_HR_WORK_EMAIL_IS_MISSING: "Hivatali email nincs megadva!",
  MY_HR_OTHER_USER_ALREADY_HAS_THIS_EMAIL: "Már egy másik felhasználó használja ezt az email címet:",
  MY_HR_IMPORT_HAS_DONE_WITH_ERROR: "Az importálás hibákkal lefutott!",
  MY_HR_IMPORT_HAS_DONE: "Az importálás hibátlanul lefutott!",
  MY_HR_ITEM_PROCESSED: "tétel feldolgozva",
  MY_HR_EMPLOYEE_IMPORTED: "dolgozó importálva",
  MY_HR_ERROR_COUNT_ON_IMPORT: "dolgozó importálásakor hiba lépett fel",
  MY_HR_INTERRUPT: "Megszakítás",
  MY_HR_USER_HAS_NO_CONTRACT: "A felhasználó jogviszony adatai hiányoznak!",
  MY_HR_USER_HAS_NO_EMPLOYEE_DATA: "A felhasználó személyi adatai hiányoznak!",
  MY_HR_APPLICATIONS: "Nyilatkozatok",
  MY_HR_CLEAR_CACHE: "Szerver átmeneti tároló törlése",
  MY_HR_CLEAR_CACHE_TEXT: "Szerver oldali átmeneti memória tároló törlése. Lehetővé teszi az adatok azonnali frissítését a JDolBer-ből.",
  MY_HR_CLEAR_CACHE_SUCCEEDED: "Szerver oldali átmeneti memória tároló sikeresen törölve.",
  MY_HR_DATE_RANGE_ERROR: "A kezdő dátum nem lehet későbbi mint a záró dátum!",
  MY_HR_FIVE_MIN_REFRESH:
    "A rendszer 5 perc múlva frissítést hajt végre, kérem a folyamatban lévő folyamatait mentse el, majd nyomjon a “Frissítés” gombra!",
  MY_HR_UPDATE_AVAIABLE: "Frissítés áll rendelkezésre",
  MY_HR_CONTRACT_OF_SERVICES: "megbízás",
  MY_HR_PROFILE_IMAGE: "Profilkép",
  MY_HR_PROFILE_IMAGE_EDIT: "Profilkép megváltoztatása",
  MY_HR_IMAGE_UPLOAD: "Kép feltöltése",
  MY_HR_DISTRICT: "Kerület",
  MY_HR_DRAG_AND_DROP: "Húzza be a fotót, vagy kattintson ide",
  MY_HR_PROFILE_IMAGE_UPLOAD_SUCCEEDED: "A kép feltöltése sikerült.",
  MY_HR_PROFILE_PROFILE_IMAGE_UPLOAD_FAILED: "A kép feltöltése nem sikerült.",
  MY_HR_PROFILE_IMAGE_UPLOAD_SIZE_FAILED: "A kép mérete túl nagy.",
  MY_HR_ADD_GROUP_ROLE: "Szerep hozzáadás",
  MY_HR_INACTIVATE_GROUP: "Inaktiválás",
  MY_HR_REMOVE_GROUP_ROLE: "Szerep elvétel",
  MY_HR_ADD_GROUP_ROLE_TITLE: "Csoportos szerep hozzáadása",
  MY_HR_INACTIVATE_GROUP_TITLE: "Csoportos inaktiválás",
  MY_HR_REMOVE_GROUP_ROLE_TITLE: "Csoportos szerep elvétel",
  MY_HR_REMOVE: "Elvesz",
  MY_HR_CLOSE: "Bezárás",
  MY_HR_MERGED: "Összesítés",
  MY_HR_CONTRACT_DATA_NOT_AVAIABLE: "Jogviszony adat jelenleg nem elérhető",
  MY_HR_UPLOAD_FILE: "Fájl feltöltés (opcionális)",
  MY_HR_ADD_NEW_ADDRESS: "Cím hozzáadása",
  MY_HR_ADDRESS_INVALIDATION: "Cím érvénytelenítése",
  MY_HR_EDIT_NAME: "Név szerkesztése",
  MY_HR_EDIT_MOTHERS_NAME: "Anyja neve szerkesztése",
  MY_HR_INVALIDITON: "érvénytelenítése",
  MY_HR_DATE_OF_VALIDITY: "Érvényesség időpontja",
  MY_HR_PREFIXNAME: "Előnév",
  MY_HR_LASTNAME: "Családnév",
  MY_HR_FIRSTNAME: "Keresztnév",
  MY_HR_MIDDLENAME: "Keresztnév 2",
  MY_HR_NAMESUFFIX: "Utónév",
  MY_HR_COUNTRYOFBIRTH: "Születési ország",
  MY_HR_PLACEOFBIRTH: "Születési hely",
  MY_HR_MOTHERSNAME: "Anyja neve",
  MY_HR_MARITALSTATUS: "Családi állapot",
  MY_HR_TAXNUMBER: "Adóazonosító jel",
  MY_HR_DATEOFBIRTH: "Születési dátum",
  MY_HR_SOCIALSECURITYNUMBER: "Társadalombiztosítási azonosító jel",
  MY_HR_IDENTITYCARDNUMBER: "Személyazonosító okmány",
  MY_HR_WORKEMAIL: "Munkahelyi email",
  MY_HR_OTHEREMAIL: "Egyéb email",
  MY_HR_STREETNAME: "Közterület neve",
  MY_HR_STREETTYPE: "Közterület jellege",
  MY_HR_STREETNUMBER: "Házszám",
  MY_HR_BUILDING: "Épület",
  MY_HR_STAIRWAY: "Lépcsőház",
  MY_HR_FLOOR: "Szint (Fszt., Em.)",
  MY_HR_DOOR: "Ajtó",
  MY_HR_MESSAGE: "üzenet",
  MY_HR_ATTACHMENTS: "Csatolmányok",
  MY_HR_ATTACHMENT: "csatolmány",
  MY_HR_MOTHERSPREFIXNAME: "Előnév",
  MY_HR_MOTHERSLASTNAME: "Családnév",
  MY_HR_MOTHERSFIRSTNAME: "Keresztnév",
  MY_HR_MOTHERSFIRSTNAME2: "Keresztnév 2",
  MY_HR_MOTHERSNAMESUFFIX: "Utónév",
  MY_HR_WORKPHONE: "Munkahelyi telefon",
  MY_HR_WORKMOBILEPHONE: "Munkahelyi mobil",
  MY_HR_PRIVATEPHONE: "Egyéb mobil",
  MY_HR_CHANGE_REQUEST_SUCCEEDED: "A változáskérelem sikeresen elfogadva",
  MY_HR_CHANGE_REQUEST_REJECTED: "A változáskérelem sikeresen elutasítva",
  MY_HR_HELPDESK_CONTACTS: "Rendszergazda elérhetőség",
  MY_HR_HELPDESK_CONTACTS_INFO: "Probléma esetén kérjük forduljon a helyi rendszergazdához.",
  MY_HR_PHONE: "Telefon",
  MY_HR_HELPDESK_URL: "Rendszergazdai URL",
  MY_HR_HELPDESK_CUSTOM_INFO_TEXT: "Egyedi tájékoztató szöveg megadása",
  MY_HR_CUSTOM_TEXT: "Egyedi szöveg",
  MY_HR_EDIT_DATE_OF_BIRTH: "Születési dátum szerkesztése",
  MY_HR_EDIT_COUNTRY_OF_BIRTH: "Születési ország szerkesztése",
  MY_HR_EDIT_PLACE_OF_BIRTH: "Születési hely szerkesztése",
  MY_HR_EDIT_GENDER: "Neme szerkesztése",
  MY_HR_EDIT_MARITAL_STATUS: "Családi állapot szerkesztése",
  MY_HR_EDIT_TAX_NUMBER: "Adóazonosító jel szerkesztése",
  MY_HR_EDIT_SOCIAL_SECURITY_NUMBER: "Társadalombiztosítási azonosító jel szerkesztése",
  MY_HR_EDIT_IDENTITY_CARD_NUMBER: "Személyazonosító okmány szerkesztése",
  MY_HR_EDIT_NATIONALITY: "Állampolgárság szerkesztése",
  MY_HR_CHANGE_REQUEST_SETTINGS_INFO: "A dolgozó változást jelenthet be a saját személyes vagy elérhetőség adataival kapcsolatban.",
  MY_HR_DELETE_REQUEST: "A kérelem törlése sikeresen megtörtént",
  MY_HR_DELETE_REQUEST_ERROR: "A kérelem törlése nem sikerült",
  MY_HR_EXAMINER_USER_GUIDE: "MyHR elbírálói kézikönyv",
  MY_HR_NOT_SAME_PASSWORD: "Az új jelszó nem egyezhet meg az aktuális jelszóval!",
  MY_HR_ESCAPE_TEXT: "Ön nem %fullname%?",
  MY_HR_CHANGE_PASSWORD: "Jelszó megváltoztatása",
  MY_HR_LOCKUP: "Bezár",
  MY_HR_REMOVE_ROLE_ERROR: "A szerep eltávolítása hibákkal lefutott!",
  MY_HR_BANK_ACCOUNT: "Bankszámlaszám",
  MY_HR_BANK_ACCOUNTS: "Bankszámlaszámok",
  MY_HR_DELETE_CHANGE_REQUEST_TEXT: "Valóban törli a kérelmet?",
  MY_HR_REJECTED_CHANGE_REQUEST: "Kérelem elutasítása",
  MY_HR_REJECTED_CHANGE_REQUEST_TEXT: "Valóban elutasítja a kérelmet?",
  MY_HR_DIRECTORY: "Címtár",
  OC_MONDAY: "Hétfő",
  OC_TUESDAY: "Kedd",
  OC_WEDNESDAY: "Szerda",
  OC_THURSDAY: "Csütörtök",
  OC_FRIDAY: "Péntek",
  OC_SATURDAY: "Szombat",
  OC_SUNDAY: "Vasárnap",
};
